export const getPreviewData = () => {
  const IS_BROWSER = typeof window !== 'undefined';
  if (IS_BROWSER && window.__PRISMIC_PREVIEW_DATA__) {
    return window.__PRISMIC_PREVIEW_DATA__;
  }
  return null;
};
